import { IPageTabNavLink } from "../interfaces-and-types";

export const reportsNavLinks: IPageTabNavLink[] = [
  {
    name: "Overview",
    route: "",
  },
  {
    name: "Balance",
    route: "balance",
  },
  {
    name: "Payout Reconciliation",
    route: "reconciliation",
  },
  {
    name: "Revenue Recognition",
    route: "revenue",
  },
];
